import { inventoryLocalization } from './translations';

const filter = document.getElementById('select-filters');

const priceMin = document.getElementById('price_min');
const priceMax = document.getElementById('price_max');
const yearMin = document.getElementById('year_min');
const yearMax = document.getElementById('year_max');
const odometerMin = document.getElementById('odometer_min');
const odometerMax = document.getElementById('odometer_max');

const category = document.getElementById('dsp_category');
const make = document.getElementById('dsp_make');
const model = document.getElementById('dsp_model');

let typeList = [category, make];
let elementList = [
  [priceMin, priceMax],
  [yearMin, yearMax],
  [odometerMin, odometerMax],
];

//add event listener to the minimums
if (filter) {
  elementList.map(function (element) {
    if (element[0] !== null) {
      return element[0].addEventListener('change', function (event) {
        let minLength = element[0].length;
        let maxLength = element[1].length;

        let index = event.target.selectedIndex;
        if (minLength - index < maxLength) {
          let adjustedIndex = maxLength - (minLength - index) - 1;

          for (let i = 0; i < adjustedIndex; ++i) {
            element[1].remove(1);
          }
        } else if (minLength - index >= maxLength) {
          let adjustedIndex = minLength - index - maxLength + 1;

          for (let i = adjustedIndex; i >= index; --i) {
            let newElement = document.createElement('option');
            newElement.value = element[0][i].value;
            newElement.text = element[0][i].text;
            element[1].add(newElement, 1);
          }
        }
      });
    }
  });

  typeList.map(function (element) {
    if (element != null) {
      element.addEventListener('change', function (event) {
        updateFilter(element.name, event.target.value);
      });
    }
  });

  function updateFilter(element, id) {
    let updateAll = 0;
    let url = new URL('/inventory/search?', window.location.href);
    loadingOption(model);

    if (element === 'dsp_make[]') {
      url += `${element}=${id}&${category.name}=${category.value}`;
    } else {
      updateAll = 1;
      loadingOption(make);

      url += `${category.name}=${category.value}`;
    }

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (updateAll === 1) {
          addOptions(make, data.make);
        }
        addOptions(model, data.model);
      });
  }

  function removeOptions(selectElement) {
    let length = selectElement.options.length - 1;
    for (let i = selectElement.options.length - 1; i >= 0; i--) {
      selectElement.remove(i);
    }
  }

  function addOptions(selectElement, data) {
    let name;
    switch (selectElement.name) {
      case 'dsp_model[]':
        name = inventoryLocalization.gettext('All Models');
        break;
      case 'dsp_make[]':
        name = inventoryLocalization.gettext('All Makes');
        break;
    }

    removeOptions(selectElement);
    let element = document.createElement('option');
    element.text = name;
    element.value = '';
    selectElement.add(element, 1);
    data.forEach(function (item) {
      let element = document.createElement('option');
      element.text = item.name + ' (' + item.doc_count + ')';
      element.value = item.id;
      selectElement.add(element, 1);
    });
  }

  function loadingOption(selectElement) {
    removeOptions(selectElement);
    let loading = document.createElement('option');
    loading.text = inventoryLocalization.gettext('Loading');
    selectElement.add(loading, 1);
  }
}
